// extracted by mini-css-extract-plugin
export default {"composition":"Home_composition__GqoC8","photoComposition":"Home_photoComposition__sP3KQ","photo1":"Home_photo1__vA5TF","photo2":"Home_photo2__UGkPt","photo3":"Home_photo3__DjKhK"};